var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step-number step-number--instruction d-flex mb-2" },
    [
      _c("i", { staticClass: "align-self-center" }, [
        _vm._v(_vm._s(_vm.count))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "step-number-container align-self-center" }, [
        _c(
          "div",
          { staticClass: "step-number-container--title text-accent-1" },
          [_c("strong", [_vm._v(_vm._s(_vm.title))])]
        ),
        _vm._v(" "),
        _vm.instruction
          ? _c("div", { staticClass: "small step-number-container--content" }, [
              _vm._v(_vm._s(_vm.instruction))
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe4068c4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe4068c4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/steps/step-simple-instructions.vue
// module id = 360
// module chunks = 0